import SEO from "../components/seo/SEO";
import Breadcrumbs from "../components/seo/Breadcrumbs";
import { PRODUCTS } from "../config/products";
import { ProductCard } from "../components/product/ProductCard";
import EmailSignup from "../components/common/EmailSignup";

export default function Products() {
  const bundle = PRODUCTS.find((p) => p.id === "ultimate-toolkit");
  const rest = PRODUCTS.filter((p) => p.id !== "ultimate-toolkit");

  return (
    <>
      <SEO
        title="Canadian Personal Finance Planners & Templates — MyFinancesGuru Tools"
        description="Google Sheets planners for Canadians: budgeting, net worth, debt payoff, mortgage, TFSA/RRSP, retirement and FIRE. Instant download via Gumroad."
        path="/products"
        keywords={["canadian budget template", "google sheets financial planner", "net worth tracker", "debt payoff planner"]}
      />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Products", to: "/products" }]} />
        <h1 className="font-heading text-4xl font-bold tracking-tight text-foreground sm:text-5xl">Planners & templates</h1>
        <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
          Premium dashboard spreadsheets that pick up where the free calculators leave off. Instant download, lifetime access, secure checkout via Stripe. New to it? Grab the free Budget Starter below.
        </p>

        <div className="mt-12 grid gap-5 lg:grid-cols-2">
          {bundle && <ProductCard product={bundle} featured />}
          {rest.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>

        <div className="mt-16 max-w-3xl">
          <EmailSignup
            source="products-lite"
            magnet="Budget Starter (Lite)"
            title="Try it free — Budget Starter (Lite)"
            description="Get a free trimmed version of our Personal Finance Dashboard. Enter your email and download it instantly — no payment needed."
            freeFile="budget-starter-lite.xlsx"
          />
        </div>
      </div>
    </>
  );
}
